module.exports = __webpack_public_path__ + "static/media/fistFlexedRight.5ebcaf0c.png";